if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                  dots: false,
                }
              },
        ]
    });

    $('.overview-cards-slider').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                  dots:true,
                }
              },
        ]
    });    

    $('.intro-slider').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        fade: true,
    });

    $('.reviews-sym-slides').slick({
        accessibility: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                  dots:true,
                  adaptiveHeight: true,
                  autoplay: false,
                }
              },
        ]
    });
    

    // ====== SLIDE COUNTER ADDITION
    // This script is used in the top-content module and the reviews module
    // to add a counter in the slider dots
    if(document.querySelector('.sym-slides') && window.screen.width > 600) {
        const counterContainer = document.querySelector('.sym-slides .slick-dots');
        const counter          = document.querySelector('.slides-counter');
        const limit            = document.querySelector('.top-content .slides-counter .total-slides') ? document.querySelector('.top-content .slides-counter .total-slides').dataset.limit : null;

        if( counterContainer && counter && limit ){
            counterContainer.append(counter);
    
            $('.sym-slides').on('afterChange', function(event, slick, currentSlide, nextSlide){
                if(currentSlide < limit){
                    counter.querySelector('.current-slide').textContent = currentSlide + 1;
                } else {
                    counter.querySelector('.current-slide').textContent = 1;
                }
            });
        }
    }

    if(document.querySelector('.reviews-block')) {
        const counterContainer = document.querySelector('.reviews-block .slick-dots');
        const counter          = document.querySelector('.reviews-block .slides-counter');
        const limit            = document.querySelector('.reviews-block .slides-counter .total-slides').dataset.limit;

        if( counterContainer && counter && limit ){
            counterContainer.append(counter);

            $('.reviews-block').on('afterChange', function(event, slick, currentSlide, nextSlide){
                if(currentSlide < limit){
                    counter.querySelector('.current-slide').textContent = currentSlide + 1;
                } else {
                    counter.querySelector('.current-slide').textContent = 1;
                }
            });
        }
    }

    // ====== END SLIDE COUNTER ADDITION

    // ====== START 'SCROLL TO' FUNCION

    window.onload = function() {
        let sectionId = location.hash.substring(1);
        let section = document.getElementById(sectionId);
        let all_anchor_with_id_as_href = document.querySelectorAll('a:not([data-fancybox])');
    
        all_anchor_with_id_as_href.forEach( each_anchor => {
            each_anchor.addEventListener( 'click', (e) => {
                if( document.getElementById(each_anchor.hash.substring(1)) ){
                    e.preventDefault();
                    section = document.getElementById(each_anchor.hash.substring(1));
                    window.scrollTo(0, section.offsetTop - 100);
                }
            } );
        });

        if (section) { 
            setTimeout(() => {
                window.scrollTo(0, section.offsetTop - 100);
            }, 1000);
        }
    };

    // ====== END 'SCROLL TO' FUNCION

    // ====== FORMS LABEL FUNCTIONALITY
    // this fuction is used in the forms and email signup module
    // to move the label up when the input is focused
    function updateFormLabelsPosition({ inputsCollection }) {
        inputsCollection.forEach( input => {
            input.addEventListener('focus', function(e){
                input.previousElementSibling.style.transition = "all .3s ease-in-out";
                input.previousElementSibling.style.top = "-12px";
                input.previousElementSibling.style.left = "5px";
                input.previousElementSibling.style.fontSize = "11px";
            })
        });
    }

    if(document.querySelector('.form-module')) {
        let inputsCollection  = document.querySelectorAll('.form-module input, .form-module textarea, .form-module select');
        updateFormLabelsPosition( { inputsCollection });
    }

    if(document.querySelector('.email-signup')) {
        let inputsCollection = document.querySelectorAll('.email-signup .field.input input');
        updateFormLabelsPosition( { inputsCollection });
    }
    // ====== END FORMS LABEL FUNCTIONALITY


    // ====== Columns With Filter Functionality
    if(document.querySelector('.columns-with-filter-block')) {
        let myItems = "";

        const typeSelect    = document.querySelector('.columns-with-filter-block .filter-type select'),
            guestsSelect    = document.querySelector('.columns-with-filter-block .filter-guests select'),
            clearBTN        = document.querySelector('.columns-with-filter-block .clear-btn'),
            itemsCollection = document.querySelectorAll('.columns-with-filter-block .content__item');

        function showAllItems( items ) {
            items.forEach( item => item.classList.remove('hidden') );
            typeSelect.value = 'all';
            guestsSelect.value = '';
        }

        clearBTN.addEventListener('click', () => {
            showAllItems( itemsCollection );
            guestsSelect.selectedIndex = 0;
        })

        typeSelect.addEventListener('change', function(e){
            let value = typeSelect.value;
            let guestsValue = guestsSelect.value;

            
            console.log(guestsValue !== '0');
            itemsCollection.forEach( item => {

                if(value !== 'all') {

                    item.classList.add('hidden')

                    if( guestsValue !== '0') {
                        if(item.dataset.tag.includes(value) && item.dataset.guests === guestsValue) {
                            item.classList.remove('hidden');
                        }
                    } else {
                        if(item.dataset.tag.includes(value)) {
                            item.classList.remove('hidden');
                        }
                    }

                } else {
                    showAllItems( itemsCollection)
                    guestsSelect.selectedIndex = 0;
                }
            });
        });

        guestsSelect.addEventListener('change', function(e){
            let typeValue = typeSelect.value;

            console.log({ typeValue });

            if(typeValue !== 'all') {

                itemsCollection.forEach( item => {

                    item.classList.add('hidden')

                    if(item.dataset.tag.includes(typeValue) && item.dataset.guests === guestsSelect.value) {
                        item.classList.remove('hidden');
                    }
                });
            } else {
                itemsCollection.forEach( item => {
                    item.classList.add('hidden')

                    if(item.dataset.guests === guestsSelect.value) {
                        item.classList.remove('hidden');
                    }
                });
            }
        })

    }
    // ====== END Columns With Filter Functionality



    //MOBILE BURGER MENU FUNCTIONALITY
    if(document.querySelector('.js-burger-menu')) {
        let burgerMenu = document.querySelector('.js-burger-menu');
        let menu = document.querySelector('.js-menu');

        burgerMenu.addEventListener('click', function(e){
            menu.classList.toggle('active');
            // this.classList.toggle('active');

            // this.classList.contains('active')
            //     ? this.querySelector('span').textContent = 'Close'
            //     : this.querySelector('span').textContent = 'Menu';
        });

        let closer = document.querySelector('.js-closer');

        closer.addEventListener('click', function(e){
            menu.classList.remove('active');
            burgerMenu.classList.remove('active');
            burgerMenu.querySelector('span').textContent = 'Menu';
        });

        let items_menu_mobile = document.querySelectorAll('.nav-container .navigation ul li a');
        if( items_menu_mobile ){
            items_menu_mobile.forEach( item => {
                item.addEventListener('click', (e) => {
                    if( item.href.length < 2 && item.nextElementSibling.nodeName == 'DIV' ){
                        if( item.nextElementSibling.stlye.display != 'block' ){
                            e.preventDefault();
                            item.nextElementSibling.style.display = 'block'
                        }else{
                            e.preventDefault();
                            item.nextElementSibling.style.display = 'none'
                        }
                    }else if( item.nextElementSibling.nodeName == 'DIV' ){
                        if( item.nextElementSibling.style.display != 'block' ){
                            e.preventDefault();
                            item.nextElementSibling.style.display = 'block'
                        }
                    }
                });
            });
        }

    }
    //END MOBILE BURGER MENU FUNCTIONALITY


    //REMOVE EMPTY OPTION FROM SELECT
    if(document.querySelector('.form-module-wrapper')) {
        let form = document.querySelector('.form-module-wrapper form');
        let allSelects = form.querySelectorAll('select');

        console.log(allSelects);

        allSelects.forEach( select => {
            let options = select.querySelectorAll('option');

            options.forEach( option => {
                if(option.value === '') {
                    option.textContent = '';
                }
            });
        });

    }
    // END REMOVE EMPTY OPTION FROM SELECT


    // HEADER FORM FUNCTIONALITY
    const headerFormBtn     = document.querySelector('.js-rq-proposal');
    const headerFormCloser  = document.querySelector('.header-form .js-header-form__closer');

    function toggleForm( e ) {
        e.preventDefault();
        let form = document.querySelector( '.header-form' );
        form.classList.toggle( 'active' );
    }

    function disableScrollIfElementActive() {
        var targetElement = document.querySelector(".header-form");
        
        function handleScroll() {
            if (targetElement && targetElement.classList.contains("active")) {
                // Si el elemento con clase "active" está visible, deshabilitar el scroll
                document.body.style.overflow = "hidden";
            } else {
                // Si el elemento con clase "active" ya no está visible, habilitar el scroll nuevamente
                document.body.style.overflow = "auto";
            }
        }
    
        // Manejar el evento 'scroll' para comprobar si el elemento con clase "active" está visible
        window.addEventListener("scroll", handleScroll);
    }
    
    // Llamar a la función para habilitar la detección del elemento con clase "active"
    // disableScrollIfElementActive();

    headerFormBtn.addEventListener('click', function(e){
        toggleForm( e );
        if(window.screen.width < 640) {
            disableScrollIfElementActive();
        }
    });

    headerFormCloser.addEventListener('click', function(e){
        toggleForm( e );
        if(window.screen.width < 640) {
            disableScrollIfElementActive();
        }
    });


    if(document.querySelector('.js-booknow-mobile')) {
        document.querySelector('.js-booknow-mobile').addEventListener('click', function(e){
            let form = document.querySelector( '.header-form' );
            form.classList.toggle( 'active' );
        });
    }
    // END HEADER FORM FUNCTIONALITY

})();